import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4801Model } from '../kymw4801.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * クロス商品情報一覧取得サービス
 * @export GetCrossGoodsInfoListService
 * @class GetCrossGoodsInfoListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCrossGoodsInfoListService extends PlessJsonResponderSub<any> {
  private model: KYMW4801Model;
  private successFunc: Function;
  private vo: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCrossGoodsInfoListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        CrossCode: this.vo.crossCode,
        MediumType: this.vo.mediumType,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW4801Model} model モデルクラス
   * @param {any} vo 
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetCrossGoodsInfoListService
   */
  execute(model: KYMW4801Model, vo: any, successFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getCrossGoodsInfoList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCrossGoodsInfoListService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.setCrossGoodsInfoData(data);
    }
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetCrossGoodsInfoListService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
    this.model.kymw4801Component.exit();
  }
}
